export default {
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  }
};